import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/NavBar";
import Footer from "./components/Footer/index.js";
import Home from "./Pages/Home/index.js";
import PrivacyPage from "./Pages/Privacy/index.js";
import TermsPage from "./Pages/Terms/index.js";
import DownloadPage from "./Pages/Download/index.js";
import HowItWorks from "./Pages/HowItWorks/index.js";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <div className="container">
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/download" element={<DownloadPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
          </Routes>
          <Footer />
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
